module.exports = __webpack_public_path__ + "static/media/GTEestiDisplay-Medium.ff043a19.woff2";